import DemoCard from '../DemoCard'
import { DemoSectionProps } from '../types'

const Amalgam = ({ triggerDemo }: DemoSectionProps) => {
  const demos = [
    {
      demo: 'practiceAmalgamReset',
      isReset: true,
      buttonText: 'Reset All Amalgam Data',
      features: [
        'Remove All Amalgam Data'
      ]
    },
    {
      demo: 'practiceAmalgamDemo',
      isReset: false,
      buttonText: 'Prepare Amalgam Section for a Demo',
      features: [
        'Scenario for Demo'
      ]
    }
  ]
  return (
    <DemoCard headerText='Amalgam' demos={demos} triggerDemo={triggerDemo} />
  )
}

export default Amalgam